"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CardRowButtonTextEditor_1 = require("../../../../../../shared/components/editors/CardRowButtonTextEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var CmsBannerImageEditor = /** @class */ (function (_super) {
    __extends(CmsBannerImageEditor, _super);
    function CmsBannerImageEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.key_main = "main";
        _this.key_additional = "additional";
        _this.css_type_banner_button = 2;
        return _this;
    }
    CmsBannerImageEditor.prototype.getPriorityAvail = function () {
        var _ret = [];
        for (var i = 1; i <= 10; i++) {
            _ret.push({
                key: i,
                value: "\u041F\u0440\u0438\u043E\u0440\u0438\u0442\u0435\u0442-" + i,
            });
        }
        return _ret;
    };
    CmsBannerImageEditor.prototype.componentWillMount = function () {
        // this.SID_CSS = this.props.listCssClasses.Subscribe("*", (id, data) => {
        //     this.setState({ css_classes_avail: data.data })
        // });
        var _this = this;
        this.SID_AUT = this.props.listAuthTypes.Subscribe("*", function (id, data) {
            _this.setState({ auth_types_avail: data.data });
        });
        if (this.props.record) {
            this.setState({
                title: this.props.record.title,
                lang_id: this.props.record.app_language_id,
                lang_title: this.props.record.app_language_title,
                image_url: this.props.record.image_url,
                priority_key: this.props.record.priority,
                priority_val: "\u041F\u0440\u0438\u043E\u0440\u0438\u0442\u0435\u0442-" + this.props.record.priority,
                priority_avail: this.getPriorityAvail(),
                is_locked: this.props.record.is_locked,
                is_navigate_banner: this.props.record.is_navigate_banner,
                banner_navigate_url: this.props.record.banner_navigate_url,
                //is_show_button: this.props.record.is_show_button,
                //is_navigate_button: this.props.record.is_navigate_button,
                //button_navigate_url: this.props.record.button_navigate_url,
                //button_text: this.props.record.button_text,
                //button_css_class: this.props.record.button_css_class,
                auth_type_code: this.props.record.banner_auth_type_code,
                auth_type_title: this.props.record.banner_auth_type_title,
                //tabKey: this.key_main,
                //css_classes_avail: [],
                auth_types_avail: []
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Список баннеров", "Редактирование баннера"]);
            });
        }
        else {
            this.setState({
                title: "",
                lang_id: -1,
                lang_title: "",
                image_url: "",
                priority_key: 1,
                priority_val: "\u041F\u0440\u0438\u043E\u0440\u0438\u0442\u0435\u0442-" + 1,
                priority_avail: this.getPriorityAvail(),
                is_locked: false,
                is_navigate_banner: false,
                banner_navigate_url: "",
                //is_show_button: false,
                //is_navigate_button: false,
                //button_navigate_url: "",
                //button_text: "",
                //button_css_class: "",
                auth_type_code: 0,
                auth_type_title: "",
                //tabKey: this.key_main,
                //css_classes_avail: [],
                auth_types_avail: []
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Список баннеров", "Создание баннера"]);
            });
        }
        //this.props.listCssClasses.LoadDataByType(this.css_type_banner_button);
        this.props.listAuthTypes.LoadData();
        this.doReSetRules();
    };
    CmsBannerImageEditor.prototype.componentWillUnmount = function () {
        //this.props.listCssClasses.UnSubscribe(this.SID_CSS);
        this.props.listAuthTypes.UnSubscribe(this.SID_AUT);
    };
    CmsBannerImageEditor.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false },
            lang_rules: { isError: false },
            image_url_rules: { isError: false },
            priority_rules: { isError: false },
            banner_navigate_url_rules: { isError: false },
            //button_navigate_url_rules: { isError: false },
            //button_css_class_rules: { isError: false },
            auth_type_rules: { isError: false }
        });
    };
    CmsBannerImageEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                title: this.state.title,
                app_language_id: this.state.lang_id,
                image_url: this.state.image_url,
                priority: this.state.priority_key,
                is_locked: this.state.is_locked,
                is_navigate_banner: this.state.is_navigate_banner,
                banner_navigate_url: this.state.banner_navigate_url,
                //is_show_button: this.state.is_show_button,
                //is_navigate_button: this.state.is_navigate_button,
                //button_navigate_url: this.state.button_navigate_url,
                //button_text: this.state.button_text,
                //button_css_class: this.state.button_css_class,
                banner_auth_type_code: this.state.auth_type_code
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Баннер изменен!");
            });
        }
    };
    CmsBannerImageEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({
                title_rules: { isError: true, errorMessage: "Поле [название] не заполнено!" },
            });
            return false;
        }
        if ((this.state.lang_id <= 0) || (this.state.lang_title.length === 0)) {
            this.setState({
                lang_rules: { isError: true, errorMessage: "Поле [язык] не выбрано!" },
            });
            return false;
        }
        if ((!this.state.image_url) || (this.state.image_url.length === 0)) {
            this.setState({
                image_url_rules: { isError: true, errorMessage: "Поле [ссылка на изображение] не выбрано!" },
            });
            return false;
        }
        if ((this.state.priority_key <= 0) || (this.state.priority_val.length === 0)) {
            this.setState({
                priority_rules: { isError: true, errorMessage: "Поле [приоритет] не выбрано!" },
            });
            return false;
        }
        if (this.state.is_navigate_banner) {
            if ((!this.state.banner_navigate_url) || (this.state.banner_navigate_url.length === 0)) {
                this.setState({
                    banner_navigate_url_rules: { isError: true, errorMessage: "Поле [ссылка на для навигации] не выбрано!" },
                });
                return false;
            }
        }
        //if (this.state.is_navigate_button) {
        //    if ((!this.state.button_navigate_url) || (this.state.button_navigate_url.length === 0)) {
        //        this.setState({
        //            button_navigate_url_rules: { isError: true, errorMessage: "Поле [ссылка на для навигации] не выбрано!" },
        //            tabKey: this.key_additional
        //        })
        //        return false;
        //    }
        //}
        //if (this.state.is_show_button) {
        //    if ((!this.state.button_css_class) || (this.state.button_css_class.length === 0)) {
        //        this.setState({
        //            button_css_class_rules: { isError: true, errorMessage: "Поле [css class] не заполнено!" },
        //            tabKey: this.key_additional
        //        })
        //        return false;
        //    }
        //}
        if ((this.state.auth_type_code <= 0) || (this.state.auth_type_title.length === 0)) {
            this.setState({
                auth_type_rules: { isError: true, errorMessage: "Поле [тип авторизации] не выбрано!" },
            });
            return false;
        }
        return true;
    };
    CmsBannerImageEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                banner_route_id: this.props.rootRecord.key,
                title: this.state.title,
                app_language_id: this.state.lang_id,
                image_url: this.state.image_url,
                priority: this.state.priority_key,
                is_locked: this.state.is_locked,
                is_navigate_banner: this.state.is_navigate_banner,
                banner_navigate_url: this.state.banner_navigate_url,
                //is_show_button: this.state.is_show_button,
                //is_navigate_button: this.state.is_navigate_button,
                //button_navigate_url: this.state.button_navigate_url,
                //button_text: this.state.button_text,
                //button_css_class: this.state.button_css_class,
                banner_auth_type_code: this.state.auth_type_code
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Баннер добавлен!");
            });
        }
    };
    CmsBannerImageEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    CmsBannerImageEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить баннер";
        }
        else {
            return "Изменить баннер";
        }
    };
    CmsBannerImageEditor.prototype.DoShowSelectImageDialog = function () {
        var _this = this;
        this.props.dialogSelectImage.SetDialogTitle("Выбор изображения").SetOnSelect(function (brandIdentity, dirName, fileName) {
            _this.setState({ image_url: brandIdentity + "/" + dirName + "/" + fileName }, function () {
                _this.props.dialogSelectImage.Close();
            });
        }).Show();
    };
    CmsBannerImageEditor.prototype.getDownButtons = function () {
        return (React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }));
    };
    CmsBannerImageEditor.prototype.getMainEditContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название:", placeholder: "Введите название" }, value: this.state.title, onValueChanged: function (newVal) {
                    _this.setState({
                        title: newVal,
                        title_rules: { isError: false }
                    });
                }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Язык:", placeholder: "Выберите язык" }, value: { key: this.state.lang_id, value: this.state.lang_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        lang_id: newVal.key,
                        lang_title: newVal.value,
                        lang_rules: { isError: false },
                    });
                }, items: this.props.languagesList, required: true, rules: this.state.lang_rules }),
            React.createElement(CardRowButtonTextEditor_1.default, { texts: {
                    caption: "Изображение:",
                    placeholder: "Выберите изображение",
                    buttonHint: "Выберите изображение"
                }, readonly: true, onButtonClick: this.DoShowSelectImageDialog.bind(this), onValueChanged: function (newVal) {
                    _this.setState({
                        image_url: newVal,
                        image_url_rules: { isError: false }
                    });
                }, value: this.state.image_url, buttonIcon: "search", required: true, rules: this.state.image_url_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Приоритет:", placeholder: "Выберите приоритет" }, value: { key: this.state.priority_key, value: this.state.priority_val }, onValueChanged: function (newVal) {
                    _this.setState({
                        priority_key: newVal.key,
                        priority_val: newVal.value,
                        priority_rules: { isError: false }
                    });
                }, items: this.state.priority_avail, required: true, rules: this.state.priority_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Баннер заблокирован", value: this.state.is_locked, onChecked: function (checked) {
                    _this.setState({
                        is_locked: checked
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Навигация при щелчке", value: this.state.is_navigate_banner, onChecked: function (checked) {
                    _this.setState({
                        is_navigate_banner: checked
                    });
                } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Ссылка для навигации:", placeholder: "Введите ссылку для навигации" }, value: this.state.banner_navigate_url, onValueChanged: function (newVal) {
                    _this.setState({
                        banner_navigate_url: newVal,
                        banner_navigate_url_rules: { isError: false }
                    });
                }, required: true, rules: this.state.banner_navigate_url_rules, disabled: !this.state.is_navigate_banner }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Тип авторизации:", placeholder: "Выберите тип авторизации" }, value: { key: this.state.auth_type_code, value: this.state.auth_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        auth_type_code: newVal.key,
                        auth_type_title: newVal.value,
                        auth_type_rules: { isError: false },
                    });
                }, items: this.state.auth_types_avail, required: true, rules: this.state.auth_type_rules }),
            this.getDownButtons()));
    };
    /*private doSelectCssClass() {
        this.props.dlgSelectCss.SetTitle("Выбрать CSS класс")
            .SetHideNotAutoCloseDialog(true)
            .SetOnCloseClick(() => { this.props.dlgSelectCss.Close() })
            .SetViewData(this.state.css_classes_avail)
            .SetOnSelectClick((key, value) => {
                this.setState({
                    button_css_class: value,
                    button_css_class_rules: { isError: false }
                }, () => {
                    this.props.dlgSelectCss.Close();
                })
            }).Show();
    }*/
    /*private getAdditionalEditContent(): JSX.Element {
        return (
            <div>
                <CardRowCheckBoxEditor
                    title={"Показывать кнопку"}
                    value={this.state.is_show_button}
                    onChecked={(checked) => {
                        this.setState({
                            is_locked: checked
                        })
                    }}
                />

                <CardRowCheckBoxEditor
                    title={"Навигация по кнопке"}
                    value={this.state.is_navigate_button}
                    onChecked={(checked) => {
                        this.setState({
                            is_navigate_button: checked
                        })
                    }}
                />

                <CardRowTextEditor
                    texts={{ caption: "Ссылка для навигации:", placeholder: "Введите ссылку для навигации" }}
                    value={this.state.button_navigate_url}
                    onValueChanged={(newVal) => {
                        this.setState({
                            button_navigate_url: newVal,
                            button_navigate_url_rules: { isError: false }
                        })
                    }}
                    required
                    rules={this.state.button_navigate_url_rules}
                    disabled={!this.state.is_navigate_button}
                />

                <CardRowTextEditor
                    texts={{ caption: "Текст на кнопке:", placeholder: "Введите текст на кнопке" }}
                    value={this.state.button_text}
                    onValueChanged={(newVal) => {
                        this.setState({
                            button_text: newVal
                        })
                    }}
                />

                <CardRowButtonTextEditor
                    texts={{
                        caption: "CSS класс:",
                        placeholder: "Введите имя класса CSS",
                        buttonHint: "Выбрать CSS класс"
                    }}
                    readonly={false}
                    onButtonClick={this.doSelectCssClass.bind(this)}
                    onValueChanged={(newVal) => {
                        this.setState({
                            button_css_class: newVal,
                            button_css_class_rules: { isError: false }
                        })
                    }}
                    value={this.state.button_css_class}
                    buttonIcon={"ellipsis"}
                    rules={this.state.button_css_class_rules}
                />


                {this.getDownButtons()}

            </div>
        )
    }*/
    CmsBannerImageEditor.prototype.getContent = function () {
        //if (this.state.tabKey === this.key_main) {
        return this.getMainEditContent();
        //}
        //if (this.state.tabKey === this.key_additional) {
        //    return this.getAdditionalEditContent()
        //}
        //return null;
    };
    //private onTabChange(key: string) {
    //    this.setState({ tabKey: key })
    //}
    CmsBannerImageEditor.prototype.render = function () {
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 590 }, this.getContent()));
    };
    return CmsBannerImageEditor;
}(React.Component));
exports.default = CmsBannerImageEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_banners/ui/component/CmsBannerRouteImageEditor.tsx
// module id = 2386
// module chunks = 0